module.exports = __webpack_public_path__ + "static/media/BigBasketProducts.e2bb4789.csv";